import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import ModalForms from '../../../../components/ConfirmationModal/ModalForms';
import { useModalFeedback } from '../../../../hooks/useModalFeedback';
import { handleKeyDown } from '../../../../utils/Functions/formatAnthropometry';
import { FormikNumberInput } from '../../../../components/InputNumberValidation/FormikNumberInput';
import LoadingEllipsis from '../../../../components/LoadingEllipsis/LoadingEllipsis';
import { MdCreate } from 'react-icons/md';
import { onKeyDown } from '../../../../utils/Functions/formatAnthropometry';
import '../styles/CreateConsultationTypes.css';
import '../../../../Mobile.css';
function CreateConsultationTypes({ type = {}, onSave, onCancel: handleFormCancel }) {

  const [errors, setErrors] = useState({});
  const {
    showModal,
    message,
    showButtons,
    isDeleting,
    setIsDeleting,
    onConfirm,
    onCancel,
    showConfirmation,
    showInfo,
    hideModal,
  } = useModalFeedback();

  const icoUpdate = <MdCreate className='icon' />;

  const initialValues = {
    consultation_type_name: type.name || '',
    default_price: type.default_fee || '',
    description: type.description || '',
  };

  const validationSchema = Yup.object({
    consultation_type_name: Yup.string().required('Tipo de Consulta é obrigatório'),
    default_price: Yup.number()
      .required('Preço base é obrigatório')
      .positive('O preço deve ser um número positivo')
      .min(0, 'O preço deve ser maior que zero'),
    description: Yup.string().required('Descrição é obrigatória'),
  });


  const handleSubmit = (values) => {
    values.default_price = Number(values.default_price).toFixed(2);
    // console.log("Formulário enviado com os seguintes valores:", values);
    const payload = {
      ...type,
      name: values.consultation_type_name,
      default_fee: Number(values.default_price).toFixed(2),
      consultation_type_id: type.consultation_type_id,
      description: values.description
    };

    onSave(payload);
  };

  return (
    <>
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          onKeyDown={handleKeyDown}
        >
          {({ setFieldValue, isSubmitting, values, touched }) => {
            return (
              <>
                <h3>{type?.consultation_type_id ? 'Atualizar Tipo de Consulta' : 'Novo Tipo de Consulta'}</h3>

                <Form className='consultation_type_Form'>
                  <div className="consultation_type_Main">
                    <div className="consultation_type_ColB coluna-rolavel">
                      {/* Nome / Sobrenome */}
                      <h5>Tipo de Consulta</h5>
                      <div className="consultation_type_form-group">
                        <label htmlFor="first_name">Nome do tipo da consulta:</label>
                        <Field
                          type="text"
                          name="consultation_type_name"
                          id="consultation_type_name"
                          placeholder="Digite o nome"
                        />
                        <ErrorMessage name="consultation_type_name" component="div" className="error-message" />
                      </div>

                      <FormikNumberInput
                        name="default_price"
                        label="Preço base (R$):"
                        maxInteger={5}
                        maxDecimal={2}
                        maxValue={99999}
                        className="consultation_type_form-group"
                        id="default_price"
                      />

                      <div className="consultation_type_form-group">
                        <label htmlFor="description">Descrição do tipo da consulta:</label>
                        <Field
                          type="text"
                          name="description"
                          id="description"
                          placeholder="Digite a descrição"
                        />
                        <ErrorMessage name="description" component="div" className="error-message" />
                        {errors.description && <div className="spanMessage">{errors.description}</div>}
                      </div>
                    </div>

                    <div className="consultation_type_ColC">

                    </div>

                    <div className="form-actions">
                      {isSubmitting ? (
                        <div className="loading-container">
                          <LoadingEllipsis message={<>Enviando {icoUpdate} </>} />
                        </div>
                      ) : (
                        <div className="consultation_type_Buttons">
                          <button className='sendBtn' type='submit'>
                            {type?.consultation_type_id ? 'Atualizar' : 'Enviar'}
                          </button>
                          <div><button className='backBtn' onClick={handleFormCancel}>Voltar</button></div>
                        </div>
                      )}
                    </div>
                  </div>
                </Form>
              </>
            );
          }}
        </Formik>
        {showModal && (
          <ModalForms
            message={message}
            onConfirm={onConfirm}
            onCancel={onCancel}
            isDeleting={isDeleting}
            showButtons={showButtons}
          />
        )}
      </div>
    </>
  );
}

export default CreateConsultationTypes;